import {
	useRouter,
	type RouterContext,
	type RouterDataContext,
	type Query,
} from '@atlassian/jira-router';
import {
	viewFiltersMatcher,
	filterSubscriptionMatcher,
	matchesAnyRoute,
	viewIssuesMatcher,
} from '../route-matchers';

/**
 * Return `true` when currently viewing any of the navigable filter routes.
 */
export function useIsFiltersUrl() {
	const [{ location, query }] = useRouter();
	return isFiltersUrl(location.pathname, query);
}

/**
 * Return `true` when currently viewing any of the navigable filter routes.
 */
export function isFiltersRoute(routerContext: RouterContext | RouterDataContext) {
	const { match, query } = routerContext;
	return isFiltersUrl(match.url, query);
}

/**
 * Return `true` when the provide route matches any of the navigable filter routes.
 */
function isFiltersUrl(path: string, query: Query) {
	return matchesAnyRoute(
		path,
		query,
		viewIssuesMatcher,
		filterSubscriptionMatcher,
		viewFiltersMatcher,
	);
}
